import { httpClient } from '@/lib/api/httpClient';
export const fetchWhatsAppIntegration = () => httpClient('/api/whatsapp/integration');
export const saveWhatsAppIntegration = (settings) => httpClient('/api/whatsapp/integration', { method: 'PUT', body: JSON.stringify(settings) });

export const fetchWhatsAppWorkspace = () => httpClient('/api/whatsapp/workspace');
export const saveWhatsAppContact = (contact) => httpClient('/api/whatsapp/contacts', { method: 'POST', body: JSON.stringify(contact) });
export const sendWhatsAppTestMessage = (contactId) => httpClient('/api/whatsapp/test-message', { method: 'POST', body: JSON.stringify({ contactId }) });
